import React, { useEffect, useState } from 'react';
import { Routes, Route } from "react-router-dom";



import Dashboard from "../Customer/index";
import Table from "../Customer/Table";
import Changepassword from "../Customer/changepassword";
import Logout from "../Customer/logout";
import Editprofile from '../Customer/EditProfile';
import Upgrade from '../Customer/upgrade';
import Startpay from '../Customer/Startpay';
import Thankyou from '../Customer/thankyou';
import Table_two from '../Customer/Table_two';
import Form_two from '../Customer/Form_two';



import ScriptGeneration from '../Customer/Script_Generation';
import Chat from '../Customer/Chat';
import Support from '../Customer/Support';
import Document from '../Customer/Document';
import P404 from "../Customer/P404";
import Sidebar from "../Customer/inc/Sidebar";
import Header from "../Customer/inc/Header";
import Footer from "../Customer/inc/Footer";
import Lead from '../Customer/Lead';
import Meeting from '../Customer/Meeting';

import bgImage from '../assets/e_learning_bg4.jpg';

//import '../Backend/App.css';  





const AdminRouting = () => {

    const [isMenuCollapsed, setIsMenuCollapsed] = useState(false);

    const handleMenuToggle = () => {
        setIsMenuCollapsed(!isMenuCollapsed);

    };

    //const navigate  = useNavigate();
    //const user_typ =  localStorage.getItem('user_typ');

    useEffect(() => {
        // if(user_typ=='student'){
        // }else{
        //   navigate("/");  
        // }
    }, []);




    return (
        <>
            <div className={`flapt-page-wrapper ${isMenuCollapsed ? 'menu-collasped-active' : ''}`}
                style={{
                    position: 'relative',
                    minHeight: '100vh',
                }}
            >

                {/* <div style={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    backgroundImage: `url(${bgImage})`,
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                    opacity: 0.2,
                    zIndex: -1,
                }} /> */}

                <div style={{ position: 'relative', zIndex: 1 }}>
                    <Sidebar isMenuCollapsed={isMenuCollapsed} />
                    <div class="flapt-page-content">
                        <Header onButtonClick={handleMenuToggle} />



                        <div class="main-panel">
                            <div class="content-wrapper">
                                <Routes>
                                    <Route exact path="/" element={<Dashboard />} />
                                    <Route exact path="/dashboard" element={<Dashboard />} />
                                    <Route exact path="/table" element={<Table />} />
                                    <Route exact path="/chat" element={<Chat />} />
                                    <Route exact path="/support" element={<Support />} />
                                    <Route exact path="/document_upload" element={<Document />} />
                                    <Route exact path="/script_generation" element={<ScriptGeneration />} />
                                    <Route exact path="/changepassword" element={<Changepassword />} />
                                    <Route exact path="/logout" element={<Logout />} />
                                    <Route exact path="/my_profile" element={<Editprofile />} />
                                    <Route exact path="/upgrade" element={<Upgrade />} />
                                    <Route exact path="/startpay/:id" element={<Startpay />} />
                                    <Route exact path="/thankyou" element={<Thankyou />} />
                                    <Route exact path="/table_two" element={<Table_two />} />
                                    <Route exact path="/form_two" element={<Form_two />} />
                                    <Route exact path="/lead" element={<Lead />} />
                                    <Route exact path="/meeting" element={<Meeting />} />





                                    <Route exact path="/*" element={<P404 />} />
                                </Routes>



                            </div>
                            <Footer />
                        </div>



                    </div>
                </div>
            </div>

























        </>
    );
};

export default AdminRouting;
